import { render, staticRenderFns } from "./PopupBannerForm.vue?vue&type=template&id=0ea8e170&"
import script from "./PopupBannerForm.vue?vue&type=script&lang=js&"
export * from "./PopupBannerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports